import { useState } from 'react';

const SCOPES = [{ v: 'year', l: 'Año en curso' }, { v: 'all', l: 'Histórico' }, { v: 'month', l: 'Mes' }, { v: 'range', l: 'Rango' }];
const dateCls = 'bg-[#16302B] border border-white/10 text-white text-xs rounded-lg px-2 py-1.5 [color-scheme:dark] focus:outline-none focus:border-[#A38560]';

export const usePeriod = () => {
  const [period, setPeriod] = useState({ scope: 'year', month: new Date().toISOString().slice(0, 7), start: '', end: '' });
  const { scope, month, start, end } = period;
  let query = `scope=${scope}`;
  if (scope === 'month') query = month ? `${query}&month=${month}` : null;
  if (scope === 'range') query = start && end && start <= end ? `${query}&start=${start}&end=${end}` : null;
  return { period, setPeriod, query };
};

export const PeriodFilter = ({ period, setPeriod, prefix }) => {
  const { scope, month, start, end } = period;
  const set = patch => setPeriod({ ...period, ...patch });
  return (
    <div className="flex flex-col items-start sm:items-end gap-2">
      <div className="flex bg-[#16302B] rounded-xl p-1 border border-white/5">
        {SCOPES.map(s => (
          <button key={s.v} data-testid={`${prefix}-scope-${s.v}`} onClick={() => set({ scope: s.v })}
            className={`px-3 py-1.5 text-xs rounded-lg transition-colors ${scope === s.v ? 'bg-[#A38560] text-[#03110D] font-semibold' : 'text-white/60 hover:text-white'}`}>{s.l}</button>
        ))}
      </div>
      {scope === 'month' && (
        <input type="month" value={month} onChange={e => set({ month: e.target.value })} data-testid={`${prefix}-month-input`} className={dateCls} />
      )}
      {scope === 'range' && (
        <div className="flex items-center gap-2 text-xs text-white/40">
          <input type="date" value={start} onChange={e => set({ start: e.target.value })} data-testid={`${prefix}-range-start`} className={dateCls} />
          <span>a</span>
          <input type="date" value={end} onChange={e => set({ end: e.target.value })} data-testid={`${prefix}-range-end`} className={dateCls} />
        </div>
      )}
      {scope === 'range' && start && end && start > end && (
        <p data-testid={`${prefix}-range-error`} className="text-[11px] text-red-400">La fecha inicial debe ser anterior a la final</p>
      )}
    </div>
  );
};
